import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { EventsService } from './services/events/events.service';
import { UserDataService } from './services/user-data/user-data.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  showFooter: boolean = false;
  app_version: string;

  constructor(
    private router: Router,
    private navController: NavController,
    private menu: MenuController,
    private userData: UserDataService,
    private eventsService: EventsService) {
  }

  async ngOnInit() {
    this.app_version = environment.APP_VERSION;

    this.eventsService.getLoginSubject().subscribe(data => {
      this.showFooter = true;
    });
    this.eventsService.getLogoutSubject().subscribe(data => {
      this.showFooter = false;
    });

    this.showFooter = await this.userData.hasLoggedIn();

    // After a full reload make sure to send the user to the home/dashboard page.
    await this.navController.navigateRoot(['']);
  }

  async logout() {
    this.showFooter = false;
    await this.menu.toggle(); // close the menu before leaving
    await this.userData.removeLoginData();
    this.router.navigate(['/login']);
  }

  // Before reloading the full page of the application ask for confirmation.
  @HostListener('window:beforeunload')
  canDeactivate() {
    return false;
  }

}
